<template>
  <Btn :label="$t('ELE0020')" @click="onClick" />
</template>

<script>
import Btn from '@/components/atoms/base/button/Btn'

export default {
  name: 'BtnClose',
  components: {
    Btn,
  },
  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>
